import { ContextMenu, ContextMenuModal, Input, MenuItem, MenuList, SelectDot } from "bimui"
import { useEffect, useState } from "react"
import { ReactComponent as DropdownSvg } from 'bimui/dist/c1/icons/collapse.svg'
import { ReactComponent as FinalDropdownSvg } from 'bimui/dist/c1/icons/final-drop.svg'
import classNames from "classnames"
import "./tree.less"
import { emitter } from "@/utils/mitt"
import { Emit_Event_Common_Tool } from "@/declare/enums/emit-event"
import { BaseUtils } from "tnbase"

export interface TreeNode {
    /**
     * 节点key
     */
    key: string,
    /**
     * 节点值的数量（1/2）
     */
    valueCount: number
    /**
     * 节点值1
     */
    value1?: string,
    /**
     * 节点值2
     */
    value2?: string,
    /**
     * 展开三角是否空心
     */
    emptySvgShow?: boolean,
    /**
     * 节点类型，区分用
     */
    type?: number,
    /**
     * 子节点列表
     */
    children?: TreeNode[],
    /**
     * 是否是自定义的节点
     */
    customize?: boolean
}

interface Iprops {
    treeList: TreeNode[]

    activeNode?: TreeNode

    searchValue?: string,

    clickEmptyToCleanActive?: boolean


    /**
     * 被选中的node
     */
    selectedNodes?: TreeNode[]

    /**
     * 需要展示的key
     */
    showItemKey: string,

    /**
     * 激活node
     * @param node 
     * @returns 
     */
    onActiveNode?: (node: TreeNode) => void

    /**
     * 单击node
     */
    onClickNode?: (e, node: TreeNode) => void

    /**
     * 编辑条目回调
     * @param node 
     * @returns 
     */
    onEditNodeConfirm: (node: TreeNode, value: string, count?: number) => void
    /**
     * 删除条目回调
     * @param node 
     * @returns 
     */
    onDeleteNodeConfirm?: (node: TreeNode, count?: number) => void
    /*
     * 双击某项
     * @returns 
     */
    onDoubleClickItem?: (node: TreeNode) => boolean
}


export default function TreeComponent(props: Iprops) {

    const { treeList, searchValue, activeNode, selectedNodes, clickEmptyToCleanActive, showItemKey, onActiveNode, onClickNode, onEditNodeConfirm, onDeleteNodeConfirm, onDoubleClickItem } = props

    const [originTreeList, setOriginTreeList] = useState<TreeNode[]>([])

    const [showTreeList, setShowTreeList] = useState<TreeNode[]>([])

    /**
     * 页面展开的item的key的列表
     */
    const [showNodeKeyList, setShowNodeKeyList] = useState<string[]>([])
    /**
     * 选中的item
     */
    const [selectNodeKeyList, setSelectNodeKeyList] = useState<string[]>([])

    /**
     * 第一个值的编辑
     */
    const [editValue1Node, setEditValue1Node] = useState<TreeNode>(null)
    /**
     * 第二个值的编辑
     */
    const [editValue2Node, setEditValue2Node] = useState<TreeNode>(null)
    /**
     * 是否显示标注菜单
     */
    const [visible, setVisible] = useState<boolean>(false);
    /**
     * 菜单的left
     */
    const [left, setLeft] = useState(0);
    /**
     * 菜单的top
     */
    const [top, setTop] = useState(0);

    /**
     * 编辑信号
     */
    const [editFlag, setEditFlag] = useState<string>();
    /**
     * 删除信号
     */
    const [deleteFlag, setDeleteFlag] = useState<string>();

    useEffect(() => {
        emitter.on(Emit_Event_Common_Tool.DELETE, () => setDeleteFlag(BaseUtils.genUUID()));
        emitter.on(Emit_Event_Common_Tool.EDIT, () => setEditFlag(BaseUtils.genUUID()));

        return () => {
            emitter.off(Emit_Event_Common_Tool.DELETE, () => setDeleteFlag(BaseUtils.genUUID()));
            emitter.off(Emit_Event_Common_Tool.EDIT, () => setEditFlag(BaseUtils.genUUID()));
        };
    }, [])

    useEffect(() => {
        if (!activeNode) return;
        if (activeNode.customize === false) return;
        setEditValue1Node(activeNode);
    }, [editFlag])

    useEffect(() => {
        if (!activeNode) return;
        if (activeNode.customize === false) return;
        // 调用外部回调，执行删除操作,并更新树节点
        onDeleteNodeConfirm(activeNode);
    }, [deleteFlag])

    useEffect(() => {
        if (!treeList) return
        if (searchValue?.length > 0) {
            setShowTreeList(filterTree(treeList, searchValue))
        } else {
            setShowTreeList([...treeList])
        }
        let showList = []
        showAllTree(treeList, showList)
        setShowNodeKeyList(showList)
        setOriginTreeList([...treeList])
    }, [treeList])

    useEffect(() => {
        if (!(showItemKey?.length > 0)) return
        if (!showNodeKeyList.includes(showItemKey)) {
            setShowNodeKeyList([
                ...showItemKey,
                showItemKey
            ])
        }
    }, [showItemKey])

    useEffect(() => {
        if (searchValue?.length > 0) {
            let filterList = filterTree([...originTreeList], searchValue)
            setShowTreeList([...filterList])
        } else {
            setShowTreeList([...originTreeList])
        }
    }, [searchValue])

    /**
     * 将所有的tree都默认打开
     * @param tree 
     * @param showKeyList 
     */
    const showAllTree = (tree: TreeNode[], showKeyList: string[]) => {
        for (let i = 0; i < tree.length; i++) {
            showKeyList.push(tree[i].key)
            if (tree[i].children?.length > 0) {
                showAllTree(tree[i].children, showKeyList)
            }
        }
    }

    const filterTree = (nodes: TreeNode[], searchString: string): TreeNode[] => {
        const result: TreeNode[] = [];

        for (const node of nodes) {
            // 递归查找子节点是否匹配
            const matchingChildren = node.children ? filterTree(node.children, searchString) : [];
            // 判断当前节点是否匹配
            const isMatch = node.value1?.includes(searchString) || node.value2?.includes(searchString);

            // 如果当前节点匹配，或者有匹配的子节点，当前节点返回
            if (isMatch || matchingChildren.length > 0) {
                result.push({
                    ...node,
                    children: matchingChildren, // 仅返回匹配的子节点
                });
            }
        }
        return result;
    };

    /**
     * 点击多选点
     * @param node 
     */
    const onClickSelectDot = (node: TreeNode) => {
        if (selectNodeKeyList.includes(node.key)) {
            setSelectNodeKeyList([...selectNodeKeyList.filter(item => item != node.key)])
        } else {
            setSelectNodeKeyList([
                ...selectNodeKeyList,
                node.key
            ])
        }
    }

    /**
     * 修改打开状态
     * @param node 
     */
    const onClickShowTreeNode = (node: TreeNode) => {
        if (showNodeKeyList.includes(node.key)) {
            setShowNodeKeyList([...showNodeKeyList.filter(item => item != node.key)])
        } else {
            setShowNodeKeyList([
                ...showNodeKeyList,
                node.key
            ])
        }
    }

    const onConfirmEditValue = (node: TreeNode, value: string, count: number) => {
        let copyTreeData = [...originTreeList]
        for (let i = 0; i < copyTreeData.length; i++) {
            changeNodeValue(copyTreeData[i], node.key, value, count)
        }
        onEditNodeConfirm(node, value, count)
    }

    const changeNodeValue = (node: TreeNode, key: string, value: string, count: number) => {
        if (node.key == key) {
            if (count == 1) {
                node.value1 = value
            } else {
                node.value2 = value
            }
            return
        }
        if (node?.children?.length > 0) {
            for (let i = 0; i < node.children.length; i++) {
                changeNodeValue(node.children[i], key, value, count)
            }
        }
    }

    // const deleteNodeFromTree = (key: string) => {
    //     const deleteNodeRecursive = (nodes: TreeNode[], key: string): TreeNode[] => {
    //         return nodes.filter((node) => {
    //             // 如果当前节点是目标节点，过滤掉它
    //             if (node.key === key) {
    //                 return false;
    //             }

    //             // 如果有子节点，递归处理
    //             if (node.children && node.children.length > 0) {
    //                 node.children = deleteNodeRecursive(node.children, key);
    //             }

    //             return true;
    //         });
    //     };

    //     // 更新树的原始列表
    //     const updatedTreeList = deleteNodeRecursive(originTreeList, key);

    //     // 更新组件的状态
    //     setOriginTreeList(updatedTreeList);
    //     setShowTreeList(updatedTreeList);
    // };



    const TreeNodeItem = (treeNode: NodeItem) => {
        return (
            <div className="node-item" key={treeNode?.node?.key}>
                <div
                    className={classNames({
                        "item-head": true,
                        "item-head-active": activeNode?.key == treeNode?.node?.key || (selectedNodes || []).some(s => s.key == treeNode?.node?.key)
                    })}
                    onClick={(e) => {
                        e.stopPropagation()
                        if (onActiveNode) {
                            onActiveNode(treeNode.node)
                        }
                        if (onClickNode) {
                            onClickNode(e, treeNode.node);
                        }
                    }}
                    onContextMenu={(e) => {
                        e.stopPropagation()
                        e.preventDefault()
                        if (activeNode?.key !== treeNode.node.key) {
                            if (onActiveNode) {
                                onActiveNode(treeNode.node)
                            }
                            if (onClickNode) {
                                onClickNode(e, treeNode.node);
                            }
                        }
                        // 判断当前对象的 customize 是否为 false
                        if (treeNode.node.customize === false) {
                            // 如果 customize 为 false，则不激活右键菜单
                            return;
                        }
                        setTop(e.clientY);
                        setLeft(e.clientX);
                        setVisible(true);
                    }}
                >
                    {/* <div className="select-dot-body">
                        <SelectDot
                            active={selectNodeKeyList.includes(treeNode.node.key)}
                            onClick={(e) => {
                                e.stopPropagation()
                                onClickSelectDot(treeNode.node)
                            }}
                            style={{ marginLeft: 4 }}
                            wrapperClassName={classNames({
                                "select-dot": true,
                                "select-dot-active": selectNodeKeyList.includes(treeNode?.node?.key)
                            })}
                        />
                    </div> */}

                    <div className="head-main" style={{
                        marginLeft: treeNode?.level * 16,
                        width: `calc(100% - ${treeNode?.level * 16}px - 16px)`
                    }}>
                        <div className="drop-down-area">
                            <>
                                {treeNode?.node?.children?.length > 0 && (
                                    <>
                                        {treeNode?.node?.emptySvgShow ? (
                                            <FinalDropdownSvg className={classNames({
                                                "drop-down-svg": true,
                                                "drop-down-svg-active": showNodeKeyList.includes(treeNode?.node?.key)
                                            })}
                                                onClick={(e) => {
                                                    e.stopPropagation()
                                                    onClickShowTreeNode(treeNode.node)
                                                }}
                                            />
                                        ) : (
                                            <DropdownSvg className={classNames({
                                                "drop-down-svg": true,
                                                "drop-down-svg-active": showNodeKeyList.includes(treeNode?.node?.key)
                                            })}
                                                onClick={(e) => {
                                                    e.stopPropagation()
                                                    onClickShowTreeNode(treeNode.node)
                                                }}
                                            />
                                        )}
                                    </>
                                )}
                            </>
                        </div>
                        <div className="head-value-1">
                            {editValue1Node?.key != treeNode.node.key ? (
                                <div onDoubleClick={() => {
                                    if (onDoubleClickItem) {
                                        let next = onDoubleClickItem(treeNode.node);
                                        if (next) {
                                            setEditValue1Node(treeNode.node);
                                        }
                                    } else {
                                        setEditValue1Node(treeNode.node)
                                    }
                                }} className="ellipsis">
                                    {treeNode?.node?.value1}
                                </div>
                            ) : (
                                <Input
                                    autoFocus
                                    onEnter={(e) => {
                                        let event = e as any
                                        onConfirmEditValue(treeNode.node, event.target.value, 1)
                                        setEditValue1Node(null)
                                    }}
                                    defaultValue={editValue1Node?.value1 || ""}
                                    onBlur={(e) => {
                                        onConfirmEditValue(treeNode.node, e.target.value, 1)
                                        setEditValue1Node(null)
                                    }} />
                            )}
                        </div>
                        {treeNode?.node?.valueCount == 2 && (
                            <div className="head-value-2">
                                {editValue2Node?.key != treeNode.node.key ? (
                                    <div onDoubleClick={() => {
                                        if (onDoubleClickItem) {
                                            let next = onDoubleClickItem(treeNode.node);
                                            if (next) {
                                                setEditValue2Node(treeNode.node);
                                            }
                                        } else {
                                            setEditValue2Node(treeNode.node)
                                        }
                                    }}>
                                        {treeNode?.node?.value2}
                                    </div>
                                ) : (
                                    <Input
                                        autoFocus
                                        defaultValue={editValue2Node?.value2 || ""}
                                        wrapClassName="head-value-input-2"
                                        onEnter={(e) => {
                                            let event = e as any
                                            onConfirmEditValue(treeNode.node, event.target.value, 2)
                                            setEditValue2Node(null)
                                        }}
                                        onBlur={(e) => {
                                            onConfirmEditValue(treeNode.node, e.target.value, 2)
                                            setEditValue2Node(null)
                                        }}
                                    />
                                )}
                            </div>
                        )}
                    </div>
                </div>
                {treeNode?.node?.children?.length > 0 &&
                    showNodeKeyList.includes(treeNode?.node?.key) &&
                    (
                        <>
                            {treeNode?.node?.children?.map((childrenNode) => (
                                <TreeNodeItem level={treeNode.level + 1} node={childrenNode} />
                            ))}
                        </>
                    )}
            </div>
        )
    }


    return (
        <>
            <div className="tree-component-main" onClick={() => {
                if (clickEmptyToCleanActive) {
                    if (onActiveNode) {
                        onActiveNode(null)
                    }
                }
            }}>
                {showTreeList?.map(nodeItem => (
                    <TreeNodeItem level={0} node={nodeItem} />
                ))}
            </div>

            <ContextMenuModal
                visible={visible}
                left={left}
                top={top}
                onCancel={() => {
                    setVisible(false);
                }}>
                <MenuList>
                    <MenuItem onClick={() => {
                        let active = activeNode || (selectedNodes.length > 0 ? selectedNodes[0] : null)
                        if (!active) {
                            setVisible(false);
                            return;
                        }
                        setEditValue1Node(active);
                        setVisible(false);
                    }}>
                        重命名
                    </MenuItem>
                    <MenuItem onClick={() => {
                        let active = activeNode || (selectedNodes.length > 0 ? selectedNodes[0] : null)
                        if (active) {
                            // 调用外部回调，执行删除操作,并更新树节点
                            onDeleteNodeConfirm(active);
                        }
                        // 关闭右键菜单
                        setVisible(false);
                    }} special>
                        删除
                    </MenuItem>
                </MenuList>
            </ContextMenuModal>

        </>
    )
}

interface NodeItem {
    node: TreeNode,
    level: number
}